module.exports = __webpack_public_path__ + "static/scale-model-of-from-nebraska-gift-shop-in-lincoln-nebraska-45b4ac260950207a8615ac49fb066edc.png";